export const agenticHero = {
  title: "Agentic AI Skill Development Program",
  subtitle: "A 7-Weeks Advanced AI Training",
  note: "FOR EXPERIENCED TECH PROFESSIONALS!",
  ctaText: "Register now",
  ctaLink: "/payments/agenticai",
};

export const agenticHighlights = [
  { label: "Live Online Instructor-led Training", icon: "live.svg" },
  { label: "AI Native Instructors", icon: "native.svg" },
  { label: "Practical from Day One", icon: "practical.svg" },
  { label: "Small Class Size", icon: "size.svg" },
  { label: "Project Based Learning", icon: "project.svg" },
  { label: "Agentic AI Certification", icon: "certificate.svg" },
];

export const agenticPrice = {
  amount: "$440",
  crossed: "N600,000",
  label: "Payment can be splitted twice!",
  ctaText: "Enrol Now",
  ctaLink: "/payments/agenticai",
};

export const module1 = {
  title: "Module 1",
  subtitle: "FOUNDATIONS + AUTOMATION AGENTS (n8n)",
  points: [
    "Understanding AI Agents & Workflow Basics",
    "What are AI agents? (Autonomous vs rule-based vs cognitive)",
    "Anatomy of an AI agent: Input, Reasoning, Action, Memory, Output",
    "Overview of n8n and how it enables agent logic",
    "Setting up your workspace (n8n Cloud and local)",
    "Integrating n8n with OpenAI API",
    'Building your first AI automation: "Email summary assistant"',
    "Building Modular Agents with n8n",
    "Chaining workflows and conditional logic",
    "Using webhooks and APIs in n8n",
    "Storing and recalling data (memory simulation)",
    "Integrating AI actions (text generation, translation, categorization)",
    'Designing a mini "Customer Response Agent"',
  ],
};

export const module2 = {
  title: "Module 2",
  subtitle: "CONTEXTUAL & COGNITIVE AGENTS (Relevance AI)",
  points: [
    "Introduction to Relevance AI",
    'What makes an agent "smart"? (Memory + context + embeddings)',
    "Introduction to Relevance AI workspace",
    "Understanding datasets, workflows, and cognitive search",
    "Connecting Relevance AI with n8n",
    'Building a "Knowledge Retrieval Agent" (AI that answers FAQs from docs)',
    "Multi-Agent Systems",
    "Multi-agent architecture (manager, worker, evaluator pattern)",
    "How to connect Relevance AI and n8n workflows",
    "Designing cooperative agents: content researcher + writer + editor",
    "Using Relevance AI's agent chains and memory store",
  ],
};

export const module3 = {
  title: "Module 3",
  subtitle: "AI AGENT WITH LANGCHAIN & VOICE AGENTS",
  points: [
    "Langchain and Langsmith",
    "Introduction to Langchain and its ecosystem",
    "Integrating Langchain with existing workflows",
    "Understanding datasets, workflows, and cognitive search",
    "Memory and context management in Langchain",
    "Voice Agents",
    "Introduction to voice agents",
    "Intro to Vapi to build voice agents",
    "Twilio for voice calls and more",
  ],
};

export const module4 = {
  title: "Module 4",
  subtitle: "DEPLOYMENT AND REAL-WORLD INTEGRATIONS",
  points: [
    "Deployment and Real-World Integrations",
    "Hosting and managing n8n workflows",
    "Connecting Relevance AI with Notion, Slack, or CRMs",
    "Monitoring and scaling agent performance",
    "Security, limits, and responsible AI use",
    "Monetizing your agent projects",
  ],
};

export const module5 = {
  title: "Module 5",
  subtitle: "FINAL PROJECT",
  points: [
    "Final Project Build + Demo Day",
    "30-min build/check-in support",
    "1-hour live demo & peer reviews",
    "Showcase: Best agent awards (most creative, most useful, best design)",
    "Project Feedback",
  ],
};

export const toolsUsed = [
  "n8n (Cloud or local setup)",
  "Relevance AI account",
  "OpenAI API key",
  "Langchain & LangSmith",
  "Vapi (voice agents)",
  "Twilio",
  "Notion / Airtable / Slack (for integrations)",
  "Google Workspace (Forms, Sheets, Gmail for assignments)",
];

export const instructors = [
  {
    name: "Grace Ajagbe",
    role: "AI Engineer / CTO, Candoora AI",
    bio: "Grace Ajagbe is a tech leader with over 10 years of experience. With a robust software development background, she has helped companies in Nigeria and the UK build lasting software products. She currently works as an AI Engineer while doubling as the Co-founder & CTO of Candoora AI, a career intelligence platform. She is also an AI Implementation Consultant for companies and organisations looking to implement AI into their operational and business systems. Beyond building products, Grace trains and mentors across the UK; she has trained 4,500+ people in tech and directly mentored 100 startup founders. Her impact has also been recognised with industry and community honours, alongside invitations to speak and moderate on growth and leadership in tech.",
    imageAlt: "Grace Ajagbe",
  },
  {
    name: "Oladipupo Bolaji",
    role: "Senior Product Manager, Fincra",
    bio: "Oladipupo Bolaji is an experienced Product Manager who has held leadership roles in technology management at Microsoft, Etranzact, and Venture Gardens Group. He has a robust background in software development and a proven track record of delivering innovative digital solutions. Currently a Senior Product Manager at Fincra Technologies, he has spearheaded strategic initiatives like launching the Cashback promo, integrating virtual accounts, stabilizing pay-in systems, and driving the company's entry into the South African market. With certifications including PMP and Certified Product Manager (AIPMM), he combines technical acumen, strategic vision, and a commitment to professional growth.",
    imageAlt: "Oladipupo Bolaji",
  },
];

export const goals = [
  "Understand how AI agents work (architecture, triggers, memory, and decision-making)",
  "Build functional AI agents using n8n, Relevance AI, and supporting tools",
  "Integrate agents with real-world tools (Notion, Slack, Gmail, CRMs, APIs)",
  "Implement, deploy, and manage agent workflows",
  "Develop a personal or business-use AI agent for yourself",
  "Lead AI transformation strategy in any organisation",
];
